(() => {
  const EVENT_VARIANT_UPDATE = 'variant:update';
  const SELECTOR = '[data-sticky-atc]';
  const DESKTOP_BREAKPOINT = 990;

  class StickyAtc {
    constructor(element) {
      this.el = element;
      this.productId = element.dataset.productId || '';
      this.currentVariantId = element.dataset.variantId || null;
      this.moneyFormat = element.dataset.moneyFormat || '{{amount}}';
      this.showOnMobile = element.dataset.showMobile === 'true';
      this.showOnDesktop = element.dataset.showDesktop === 'true';

      this.button = element.querySelector('[data-sticky-atc-submit]');
      this.title = element.querySelector('[data-sticky-title]');
      this.price = element.querySelector('[data-sticky-price]');
      this.image = element.querySelector('[data-sticky-image]');
      this.defaultImageSrc = this.image?.getAttribute('src') || '';

      this.productFormComponent = document.querySelector(
        `product-form-component[data-product-id="${this.productId}"]`
      );
      this.addToCartButton = this.productFormComponent?.querySelector('[ref="addToCartButton"]');

      this.isVisible = false;
      this.resizeHandler = this.handleResize.bind(this);
      this.variantHandler = this.handleVariantUpdate.bind(this);

      this.init();
    }

    init() {
      if (!this.button || !this.productFormComponent || !this.addToCartButton) {
        this.el.remove();
        return;
      }

      this.button.addEventListener('click', (event) => {
        event.preventDefault();
        if (this.button.disabled) return;
        this.addToCartButton.click();
      });

      this.createObserver();
      document.addEventListener(EVENT_VARIANT_UPDATE, this.variantHandler);
      window.addEventListener('resize', this.resizeHandler);
      this.handleResize();
    }

    createObserver() {
      if (!this.addToCartButton) return;
      this.intersectionObserver = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          const shouldShow = !entry.isIntersecting && this.breakpointMatches();
          this.toggle(shouldShow);
        },
        {
          threshold: 0,
          rootMargin: '0px 0px -120px 0px',
        }
      );

      this.intersectionObserver.observe(this.addToCartButton);
    }

    breakpointMatches() {
      const isDesktop = window.innerWidth >= DESKTOP_BREAKPOINT;
      return isDesktop ? this.showOnDesktop : this.showOnMobile;
    }

    handleResize() {
      if (!this.breakpointMatches()) {
        this.toggle(false);
      }
    }

    toggle(state) {
      if (state && !this.breakpointMatches()) {
        state = false;
      }

      if (this.isVisible === state) return;
      this.isVisible = state;

      if (state) {
        this.el.classList.add('sticky-atc--visible');
        this.el.setAttribute('aria-hidden', 'false');
      } else {
        this.el.classList.remove('sticky-atc--visible');
        this.el.setAttribute('aria-hidden', 'true');
      }
    }

    handleVariantUpdate(event) {
      const detail = event.detail;
      if (!detail?.data?.productId || detail.data.productId.toString() !== this.productId.toString()) return;

      const variant = detail.resource;
      if (!variant) {
        this.setUnavailable();
        return;
      }

      this.currentVariantId = variant.id;
      this.updatePrice(variant.price);
      this.updateImage(variant.featured_media);
      this.button.disabled = !variant.available;
    }

    updatePrice(value) {
      if (!this.price || typeof value === 'undefined') return;
      this.price.textContent = this.formatMoney(value);
    }

    updateImage(featuredMedia) {
      if (!this.image) return;

      const src = featuredMedia?.preview_image?.src;
      if (src) {
        this.image.src = `${src}&width=160`;
      } else if (this.defaultImageSrc) {
        this.image.src = this.defaultImageSrc;
      }
    }

    setUnavailable() {
      this.button.disabled = true;
    }

    formatMoney(cents) {
      if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents, this.moneyFormat);
      }
      return (cents / 100).toFixed(2);
    }
  }

  function initStickyAtc() {
    document.querySelectorAll(SELECTOR).forEach((element) => {
      if (!element.__stickyATCInstance) {
        element.__stickyATCInstance = new StickyAtc(element);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyAtc);
  } else {
    initStickyAtc();
  }
})();

